<app-form-shell [title]="data.formValue.bookingId == null ? 'Nueva cita' : 'Editar cita'" [mode]="mode" (expand)="expand()"
  (close)="onCancel()">
  <form [formGroup]="form" class="appointment-form container-fluid">
    <!-- Location selector -->
    <div class="row">
      <div [ngClass]="getColumnClass()">
        <app-autocomplete [control]="form.get('locationUid')" [config]="{
            label: 'Centro de trabajo',
            placeholder: 'Seleccionar centro de trabajo...',
            loadOptions: getLocations.bind(this),
            onChange: onLocationChange
          }">
        </app-autocomplete>
        <small *ngIf="showEmployeeMultiLocationHint" class="text-muted d-block mt-1">
          Este empleado trabaja en varios centros de trabajo, selecciona uno.
        </small>
      </div>
    </div>

    <!-- Employee, Client, Concept -->
    <div class="row">
      <div [ngClass]="getColumnClass()">
        <app-autocomplete [control]="form.get('employeeUid')" [config]="{
            label: 'Empleado',
            placeholder: 'Buscar o crear empleado...',
            options: employees
          }">
        </app-autocomplete>
      </div>

      <div [ngClass]="getColumnClass()">
        <app-autocomplete [control]="form.get('contactUid')" [config]="{
            label: 'Cliente',
            placeholder: 'Buscar o crear cliente...',
            loadOptions: getContacts.bind(this),
            allowCustomValues: true,
            customValueLabel: 'Usar este cliente',
            onChange: onContactChange
          }">
        </app-autocomplete>
      </div>

      <div [ngClass]="getColumnClass()">
        <app-autocomplete [control]="form.get('conceptUid')" [config]="{
            label: 'Concepto',
            placeholder: 'Buscar o crear concepto...',
            options: concepts,
            onChange: onConceptChange
          }">
        </app-autocomplete>
      </div>
    </div>

    <!-- Customer fields -->
    <div class="row">
      <div [ngClass]="getColumnClass()">
        <app-field [control]="form.get('customerEmail')" [config]="{
            label: 'Email cliente',
            type: 'email'
          }">
        </app-field>
      </div>
      <div [ngClass]="getColumnClass()">
        <app-field [control]="form.get('customerPhone')" [config]="{
            label: 'Teléfono cliente',
            type: 'text'
          }">
        </app-field>
      </div>
    </div>

    <!-- Date -->
    <div class="row">
      <div [ngClass]="getColumnClass()">
        <app-date [control]="form.get('date')" [config]="{ label: 'Fecha' }"></app-date>
      </div>
    </div>

    <!-- Time -->
    <div class="row">
      <div [ngClass]="getColumnClass()">
        <app-time [control]="form.get('startTime')" [config]="{ label: 'Inicio' }"></app-time>
      </div>

      <div [ngClass]="getColumnClass()">
        <app-time [control]="form.get('endTime')" [config]="{ label: 'Fin' }"></app-time>
      </div>
    </div>

    <!-- Notes -->
    <div class="mb-3">
      <app-textarea [control]="form.get('notes')"
        [config]="{ label: 'Notas', placeholder: 'Añade observaciones...', rows: 3 }"></app-textarea>
    </div>
  </form>

  <!-- Action buttons -->
  <div class="container-fluid">
    <div class="row">
      <div [ngClass]="getColumnClass()" class="mb-2">
        <app-button *ngIf="data.formValue.uid != null" label="Generar presupuesto" variant="primary"
          className="pull-right w-100" (click)="onGeneratePreinvoice()"></app-button>
      </div>

      <div [ngClass]="getColumnClass()" class="mb-2">
        <app-button *ngIf="data.formValue.uid != null" label="Generar ticket" variant="primary"
          className="pull-right w-100" (click)="onGenerateTicket()"></app-button>
      </div>

      <div [ngClass]="getColumnClass()" class="mb-2">
        <app-button *ngIf="data.formValue.uid != null" label="Cancelar cita" icon="cancel" variant="danger"
          className="pull-right w-100" [loading]="isDeleting" (click)="onDelete()"></app-button>
      </div>

      <div [ngClass]="getColumnClass()" class="mb-2">
        <app-button label="Guardar" icon="save" variant="primary" className="pull-right w-100" [loading]="isSaving"
          (click)="onSave()"></app-button>
      </div>
    </div>
  </div>
</app-form-shell>